import { ClientLayerError } from 'shared/errors/clientLayerError'

/** Logged when a folder is not found by path in the CMS store. */
export class FolderMissingError extends ClientLayerError {
  static readonly className: string = 'FolderMissingError'

  constructor(path: string) {
    super(`Folder not found: ${path}`)
    this.setMarkupOptions({ scope: 'cms', section: 'folders' })
    this.addFingerprintSegment('folder-missing')
  }
}

/** Logged when an automation modal is rendered but its data is null. */
export class AutomationModalDataMissingError extends ClientLayerError {
  static readonly className: string = 'AutomationModalDataMissingError'

  constructor(modalType: string) {
    super(`${modalType} modal expects to have non nullable state when it is opened`)
    this.setMarkupOptions({ scope: 'cms', section: 'automation_modals' })
    this.addFingerprintSegment('automation-modal-data-missing')
  }
}
